export const getDashboardPageStyles = (theme) => ({
  pageWrapper: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: { padding: theme.spacing(1) },
  },
  pageHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: "1.9rem",
    color: "#0f2d4d",
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: "#6b7280",
    fontSize: "0.9rem",
    marginTop: 2,
  },
  primaryBtn: {
    backgroundColor: "#1769d6",
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    padding: "8px 18px",
    boxShadow: "0 4px 10px rgba(23,105,214,0.25)",
    "&:hover": { backgroundColor: "#125bbd" },
  },
  noteBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: "#eef4ff",
    border: "1px solid #d6e4ff",
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    backgroundColor: "#1769d6",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: "1px solid #e6eaf0",
    boxShadow: "0 2px 10px rgba(16,42,67,0.06)",
    marginBottom: theme.spacing(2),
    overflow: "hidden",
  },
  filtersHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2),
    borderBottom: "1px solid #eef1f5",
    backgroundColor: "#fafbfc",
  },
  filtersBody: {
    padding: theme.spacing(2),
  },
  filterLabel: {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#46566b",
    marginBottom: 6,
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  resetBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    color: "#46566b",
  },
  applyBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: "#1769d6",
    color: "#fff",
    "&:hover": { backgroundColor: "#125bbd" },
  },
  tableCard: {
    borderRadius: 14,
    border: "1px solid #e6eaf0",
    boxShadow: "0 2px 10px rgba(16,42,67,0.06)",
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderBottom: "1px solid #eef1f5",
  },
  iconBtnOutlined: {
    border: "1px solid #e6eaf0",
    borderRadius: 8,
    padding: 7,
  },
  headCell: {
    backgroundColor: "#f4f6fa",
    color: "#46566b",
    fontWeight: 700,
    fontSize: "0.8rem",
    borderBottom: "1px solid #e6eaf0",
    whiteSpace: "nowrap",
  },
  classChip: {
    backgroundColor: "#eef4ff",
    color: "#1769d6",
    fontWeight: 600,
    height: 24,
  },
  areaChip: {
    backgroundColor: "#e8f0fe",
    color: "#0f2d4d",
    fontWeight: 600,
    height: 24,
  },
  nameChip: {
    backgroundColor: "#f3efff",
    color: "#7c4dff",
    fontWeight: 600,
    height: 24,
  },
  iconAction: {
    padding: 6,
    color: "#46566b",
    "&:hover": { backgroundColor: "#f1f5fb", color: "#1769d6" },
  },
  deleteIcon: {
    padding: 6,
    color: "#46566b",
    "&:hover": { backgroundColor: "#ffebee", color: "#c62828" },
  },
  viewIcon: {
    padding: 6,
    color: "#46566b",
    "&:hover": { backgroundColor: "#eef4ff", color: "#1769d6" },
  },
  disabledIcon: {
    opacity: 0.35,
    cursor: "not-allowed",
  },
  dialogPaper: {
    borderRadius: 14,
    maxWidth: 480,
    width: "95%",
  },
  dialogTitleBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2.5),
    borderBottom: "1px solid #eef1f5",
    backgroundColor: "#fafafa",
  },
  dialogTitleText: {
    fontWeight: 700,
    fontSize: "1.15rem",
    color: "#0f2d4d",
  },
  dialogBody: {
    padding: theme.spacing(2.5),
  },
  fieldLabel: {
    display: "block",
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "#46566b",
    marginBottom: 6,
  },
  dialogFooter: {
    padding: theme.spacing(1.5, 2.5),
    borderTop: "1px solid #eef1f5",
    backgroundColor: "#fafafa",
    gap: theme.spacing(1),
  },
  cancelBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    color: "#46566b",
  },
  saveBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: "#1769d6",
    color: "#fff",
    boxShadow: "0 4px 10px rgba(23,105,214,0.25)",
    "&:hover": { backgroundColor: "#125bbd" },
  },
  uploadBtn: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: "#1769d6",
    color: "#fff",
    marginLeft: theme.spacing(1),
    "&:hover": { backgroundColor: "#125bbd" },
  },
});
